// extracted by mini-css-extract-plugin
module.exports = {"Title":"sectionTitle-module--Title--3kQr3","Dark":"sectionTitle-module--Dark--TYmuK","White":"sectionTitle-module--White--pGOoD"};